<template>
  <div class="-asset-actions">
    <wt-asset-menu
      @edit="$emit('edit')"
      @delete="$emit('delete')"
      @active="$emit('menuActive', $event)"
      :canEdit="canEdit"
      :canDelete="canDelete"
    />
    <wt-asset-add @add="$emit('add')" v-if="!selected && !isVideo" />
    <wt-asset-remove @remove="$emit('remove')" v-if="selected && !isVideo" />
    <wt-asset-cut @cut="$emit('preview-asset')" v-if="isVideo"></wt-asset-cut>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetMenu from 'components/assets/mixins/AssetMenu.vue';
import Vue from 'vue';

export default Vue.extend({
  mixins: [AssetMixins],
  components: {
    'wt-asset-menu': AssetMenu,
  },

  computed: {
    canDelete() {
      return this.isINFOGRX || this.isInMyGallery;
    },
    isINFOGRX() {
      return app.assetType.isINFOGRX(this.asset);
    },
    isInMyGallery() {
      return this.asset.metadata.providerId === 'asset_server';
    },
    isVideo() {
      return (
        app.assetType.isVIDEO(this.asset) ||
        app.assetType.isSOCIALVIDEO(this.asset)
      );
    },
    canEdit() {
      return (
        !this.isINFOGRX &&
        (app.assetType.isAssetFromEditableProvider(this.asset) ||
          this.isInMyGallery)
      );
    },
  },

  methods: {},
});
</script>
